import Cookies from "js-cookie";
import EventEmitter from "events";
import Renderer from "./Renderer";
import Analytics from "./utils/Analytics";

export default class GatedContent extends EventEmitter {
    constructor(config) {
        super();

        this.config = config;
        if (this.config.date_modified === undefined) {
            this.config.date_modified = Date.now();
        }

        this.activeGate = null;
        this.gateUnlocked = Cookies.get(`submittedFormHash${this.config.identifier}`) === "true";
        this.analytics = new Analytics();
    }

    initGate(issueId, orderedSpreads) {
        this.issueId = issueId;
        this.orderedSpreads = orderedSpreads;
        this._template = document.getElementById("HB-gated");
        if (!this._template) {
            console.error("MAGLR ERROR: Notification template not found");
        }
        this.gateUnlocked && this.emit("GATE_UNLOCKED", { issueID: this.issueId });
    }

    checkGate(spreadId) {
        if (!this.gateUnlocked && this.orderedSpreads.indexOf(spreadId) >= this.config.settings.show_at_index) {
            this.render();
        }
    }

    hasActiveGate() {
        return this.activeGate && !this.gateUnlocked;
    }

    render() {
        if (this.activeGate) {
            return;
        }

        const html = Renderer.renderSource(this._template.innerHTML, {
            url: this.getGatedFormUrl(),
            type: !this.config.form_hash && this.config.embedHash ? "singlepageGate" : "formGate",
            closeButton: this.config.settings.allow_without_submission,
            overlayColor: this.config.settings.color_overlay,
            closeColor: this.config.settings.color_close_button,
            closeText: window.interface_settings?.settings?.text?.button_close_overlay,
            frameName: window.interface_settings?.settings?.text?.gated_content_title,
        });

        this.activeGate = document.createElement("div");
        this.activeGate.setAttribute("id", `gatedContentWrapper-${this.config.identifier}`);
        this.activeGate.innerHTML = html;
        document.body.appendChild(this.activeGate);

        this.gateFrame = this.activeGate.querySelector("iframe");

        this.config.settings.allow_without_submission &&
            this.activeGate.querySelector("button.gated-close").addEventListener("click", () => {
                this.close();
            });

        //show after delay, could be 0
        setTimeout(() => {
            document.body.classList.add("gateActive");
            this.analytics.sendEventUpdate(
                this.analytics.createUserEvent(["Interface-viewer", `Gate-activated`, this.config.name]),
            );
        }, this.config.settings.delay * 1000);
    }

    close(bySubmit = false) {
        document.body.removeChild(this.activeGate);
        document.body.classList.remove("gateActive");
        this.gateUnlocked = true;

        this.emit("GATE_UNLOCKED", { issueID: this.issueId });
        !bySubmit &&
            this.analytics.sendEventUpdate(
                this.analytics.createUserEvent(["Interface-viewer", `Gate-closed-manually`, this.config.name]),
            );
    }

    getGatedFormUrl() {
        if (this.config.embedHash) {
            return `${window.embed_domain}/${this.config.embedHash}`;
        } else if (!this.config.form_hash && this.config.src) {
            return this.config.src;
        } else {
            return `${window.forms_domain}?hash=${this.config.form_hash}&form_id=${this.config.form_id}&language=${window.frontend.getLanguageId()}&clientid=${window.client_id}&t=${this.config.date_modified}&formmode=gated`;
        }
    }

    setHeight(height) {
        const box = this.activeGate?.querySelector?.(".gated-box");
        if (box) {
            box.style.height = `${height}px`;
        }
    }

    formSubmitted() {
        this.close(true);
        GatedContent.setCookie(this.config.identifier);
        this.analytics.sendEventUpdate(
            this.analytics.createUserEvent([
                "Interface-viewer",
                `Gate-form-submitted`,
                this.config.name,
                this.config?.form_hash,
            ]),
        );
    }

    checkMessageOrigin(origin) {
        return origin === this.gateFrame?.contentWindow;
    }

    static setCookie(identifier) {
        Cookies.set(`submittedFormHash${identifier}`, true);
    }
}
